// extracted by mini-css-extract-plugin
module.exports = {"add":"AddCircle_add__35wau","circle":"AddCircle_circle__d7_V7","label":"AddCircle_label__2vNB1"};